import { createTheme, createVariant, globalTheme } from '@cld/component-theme';
import { IconSize } from './types';

const spacing = globalTheme.spacing;

export const theme = createTheme({
  bySize: {
    xs: { width: spacing.xs },
    sm: { width: spacing.sm },
    md: { width: spacing.md },
    lg: { width: spacing.lg },
    xl: { width: spacing.xl },
    xxl: { width: spacing.xxl },
  },
});

export interface ThemeProps {
  size: IconSize;
}

export const iconNextSizeVariant = createVariant((props: ThemeProps) => theme.bySize[props.size]);
